import { useCallback, useEffect, useState } from 'react';
import { Container, Option } from './styles';
import { AnswerType } from '../../types/entities';

const UPPER_CASE_A_ASCII_CODE = 65;

type AnswersPropTypes = {
  options: AnswerType[];
  isLoading: boolean;
  correctAnswerId?: number;
  selectedAnswerId?: number;
  onSelectAnswer: (option: AnswerType) => void;
  disabled?: boolean;
  /** Survey mode: highlight selection only, no right/wrong styling */
  hideCorrectAnswer?: boolean;
};

export const Answers = ({
  options,
  isLoading,
  onSelectAnswer,
  disabled,
  correctAnswerId,
  selectedAnswerId,
  hideCorrectAnswer = false,
}: AnswersPropTypes) => {
  const [delayedDisabled, setDelayedDisabled] = useState(disabled);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (!disabled) {
      timer = setTimeout(() => setDelayedDisabled(false), 1000);
    } else {
      setDelayedDisabled(disabled);
    }
    return () => clearTimeout(timer);
  }, [disabled]);

  const onSelect = useCallback(
    (option: AnswerType) => () => !selectedAnswerId && !disabled && onSelectAnswer?.(option),
    [selectedAnswerId, disabled, onSelectAnswer],
  );

  const withSmallSize = options.some((o) => o.content.length > 50);
  const compact = options.length >= 5;

  return (
    <Container isLoading={isLoading} disabled={delayedDisabled} optionCount={options.length}>
      {options.map((option, index) => (
        <Option
          key={option.id}
          onClick={onSelect(option)}
          alreadyAnswered={!!selectedAnswerId}
          correct={!hideCorrectAnswer && correctAnswerId === option.id}
          withSmallSize={withSmallSize}
          selectedAnswer={selectedAnswerId === option.id}
          compact={compact}>
          {String.fromCharCode(UPPER_CASE_A_ASCII_CODE + index)}. {option.content}
        </Option>
      ))}
    </Container>
  );
};
